const isStaging = process.env.NEXT_PUBLIC_APP_ENV === 'staging'

export { isStaging }
